
import React from 'react';
import "./GetStreetView.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/reducers/root';
import { getSnapShotState } from "../../../../redux/reducers/getSnapshotInfoReducer/getSnapshotInfoReducer";
import { useTranslation } from 'react-i18next';

const streetViewApiKey = process.env.REACT_APP_STREET_VIEW_KEY;
declare const screen: Screen;
const google = window.google;
interface StreetViewProp {
    // 0: -, 1:+, 2: do not show
    coords: Array<number>;
    address: string;
}
let myLatLng: object;
export default function GetStreetView (props: StreetViewProp) {

    const { t } = useTranslation("nbhd");

    const lon = props.coords[1];
    const lat = props.coords[0];
    const snapShotInfo = useSelector((state: RootState) => state.SnapShotReducer.snapShotInfo as getSnapShotState);
    let municipality = '';
    if (snapShotInfo) {
        if (snapShotInfo['snapShotInfo']) {
            if(snapShotInfo['snapShotInfo']['message'] !==  "Not a Snapable property") {
                const snapInfo = snapShotInfo['snapShotInfo']
                municipality = "data" in snapInfo ? snapInfo['data']['municipality'] : "";
            }
        }      
    }   
    const provCountry = " Ontario CANADA";
    const address = props.address.replace(/\s\s+/g, ' ') + municipality + provCountry; 
    const streetView = () => {
        if(snapShotInfo['snapShotInfo']['message'] !==  "Not a Snapable property") {
            const directionsService = new google.maps.DirectionsService();
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                'address': address
            }, function(results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                myLatLng = {lat:lat, lng:lon};

                const request = {
                    origin: address,
                    destination: address,
                    travelMode: google.maps.DirectionsTravelMode.DRIVING
                };
                directionsService.route(request, directionsCallback);
            } else {
                console.log("Geocode was not successful for the following reason: " + status);
            }
        });
        }
    };
    return<>
    <img className='MapBoxImg' src="/images/DefaultPropertyImage.jpg" alt=""></img>
    <div
            role="button"
            className="street-buttons"
            style={{ zIndex: 999 }}
            onClick={() => {
                streetView()
            }}
          >
            <div className="text-white font-weight-bold">
              {t("nbhd.popup-card.street-view")} &nbsp; <FontAwesomeIcon icon={faUpRightFromSquare} aria-label="street-view-btn" />
            </div>
          </div>
    </>;
}


function popupwindow(url: string, w: number, h: number) {
    const left = (screen.width/2)-(w/2);
    const top = (screen.height/2)-(h/2);
    return window.open(url,'popUpWindow', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
}


function processSVData(data:object, status:number) {
    if (status === google.maps.StreetViewStatus.OK) {

        const heading = google.maps.geometry.spherical.computeHeading(data.location.latLng, myLatLng);
        const url = `https://www.google.com/maps/embed/v1/streetview?key=${streetViewApiKey}&location=${myLatLng.lat},${myLatLng.lng}&heading=${heading}&region=CA`;
        popupwindow(url,1200,600);
    } else {
        console.log("Street View data not found for this location.");
    }
}

function directionsCallback(response:object, status:number) {
    
    const sv = new google.maps.StreetViewService();
    if (status === google.maps.DirectionsStatus.OK) {
        const latlng = response.routes[0].legs[0].start_location;
        sv.getPanoramaByLocation(latlng, 50, processSVData);
    } else {
        console.log("Directions service not successfull for the following reason:" + status);
        
    }
}

